module.exports = __webpack_public_path__ + "img/forward.1d803f0b.svg";